module.exports = __webpack_public_path__ + "img/logo-palmira.f885295a.svg";